module.exports = __webpack_public_path__ + "static/media/footerLeaves.7550cf8b.svg";